import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { getDetailPagin } from 'src/common/helper';
import Pagin, { PaginationType } from 'src/components/common/Pagin';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import Rows from './Rows';

const MailList = () => {
  const [data, setData] = useState<any>([]);
  const [pagination, setPagination] = useState<PaginationType>();

  const getEmails = async (page: number) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      postAPI(`/master/email-search?token=${token}`, {
        page: page,
        pagesize: 10,
      })
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setData(res.data.items);
            setPagination(res.data.pagination);
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    getEmails(1);
    // eslint-disable-next-line
  }, []);

  const handlePageChange = (eventL: any, value: number) => {
    getEmails(value);
  };
  return (
    <Stack width={'100%'}>
      <TableContainer component={Paper}>
        <Table
          sx={{
            minWidth: 650,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '10px',
            },
          }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell>テンプレート名</TableCell>
              <TableCell>カテゴリー</TableCell>
              <TableCell>ステータス</TableCell>
              <TableCell>最終更新日</TableCell>
              <TableCell>最終更新者</TableCell>
              <TableCell>承認者</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 &&
              data.map((item: any, index: number) => (
                <Rows item={item} key={index} />
              ))}
            {data.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={7}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data.length > 0 && pagination && (
        <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
          <Typography
            component='label'
            sx={{
              color: '#AAB2BD',
              fontWeight: '400',
              fontSize: '10px',
              lineHeight: '12px',
            }}
          >
            {getDetailPagin(pagination)}
          </Typography>
        </Box>
      )}
      {data.length > 0 && pagination && pagination.page && (
        <Pagin handlePageChange={handlePageChange} pagination={pagination} />
      )}
    </Stack>
  );
};

export default MailList;
